"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const EditorButton = ({ children, disabled, isActive, onClick, ...props }) => {
    const handleClick = () => {
        if (disabled) {
            return;
        }
        onClick();
    };
    return (react_1.default.createElement(IconButton_1.default, { ...props, color: isActive ? 'primary' : undefined, disabled: disabled, size: "small", onClick: handleClick, tabIndex: -1 }, children));
};
exports.default = EditorButton;
